<script lang="ts" setup>
import { format, parse } from 'date-fns';
import { computed, ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: () => false,
  },
});

function isValid(v: string): boolean {
  try {
    return format(parse(v, 'dd-MM-yyyy', new Date()), 'dd-MM-yyyy') === v;
  } catch {
    //void
  }
  return false;
}

const dateRules = [
  (value: string) => {
    if (value.match(/\d{2}\-\d{2}\-\d{4}/g) !== null) return true; // eslint-disable-line

    return 'Please write dates as dd-mm-yyyy';
  },
  (value: string) => {
    if (isValid(value)) return true; // eslint-disable-line

    return 'Please use valid dates';
  },
];

const emit = defineEmits(['update:modelValue']);

const date = ref<string>(props.modelValue);

const dateLong = computed<string>(() => {
  return isValid(date.value)
    ? format(parse(date.value, 'dd-MM-yyyy', new Date()), 'MMMM do yyyy')
    : '';
});

function update() {
  if (isValid(date.value)) {
    emit('update:modelValue', date.value);
  } else {
    emit('update:modelValue', null);
  }
}

watch(
  () => props.modelValue,
  (v: string) => {
    date.value = v;
  },
);
</script>
<template>
  <v-text-field
    :label="props.label"
    placeholder="dd-mm-yyyy"
    :rules="dateRules"
    :required="required"
    :hint="dateLong"
    v-model="date"
    @change="update"
    @keydown="update"
    @keyup="update"
  ></v-text-field>
</template>
